import { Component, inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { environment } from '../environments/environment';
import { MATERIAL_MODULES } from './Common/material.config';

import { CustomerService } from './Common/services/customer.service';
import { ModalWindowService } from './Common/modal-window/modal-window.service';
import { AboutAppComponent } from './about-app/about-app.component';
// import { DescargarApkCheckEntradaComponent } from './descargar-apk-check-entrada/descargar-apk-check-entrada.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
    styleUrl: './app.scss',
    standalone: true,
    imports: [RouterOutlet, ...MATERIAL_MODULES],
})
export class AppComponent {
    // Inyección de dependencias moderna con inject()
    private readonly _CustomerS = inject(CustomerService);
    private readonly _ModalWindowS = inject(ModalWindowService);
    public readonly locale_id = inject(LOCALE_ID);

    public readonly title = environment.title;

    constructor() {
        console.log('locale', this.locale_id);
    }

    // Método convertido a getter para usar con @if en el template
    public get isLogged(): boolean {
        return this._CustomerS.logged !== null;
    }

    // Si CustomerService.logged fuera una señal, podrías hacer:
    // public readonly isLogged = computed(() => this._CustomerS.logged() !== null);

    public logout(): void {
        this._CustomerS.submitLogout();
    }

    public about(): void {
        this._ModalWindowS.showComponent(AboutAppComponent, null).subscribe();
    }
}